/**
 * Path Instance — traversal of a Path within one Loop (canon 29 §2.2).
 */

export type PathInstanceSource = 'track_metadata' | 'virtual' | 'adjusted' | 'seeded';

export interface PathInstanceTraverseStop {
  org_unit_id: string;
  ball_id?: string | null;
  turn_id?: string | null;
  direction?: string;
  at?: string;
}

export interface CatchballPathInstance {
  id: string;
  loopId: string;
  workspaceId: string | null;
  pathSource: PathInstanceSource;
  /** Planned Path at loop open (best-known spine). */
  spineOrgUnitIds: string[];
  /** Remaining stops from here down — holder-adjustable when policy allows. */
  remainingSpine: string[];
  traversed: PathInstanceTraverseStop[];
  splits: Array<Record<string, unknown>>;
  adjustedBy: string | null;
  adjustedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export function rowToPathInstance(row: Record<string, unknown>): CatchballPathInstance {
  const asStringArray = (v: unknown): string[] => {
    if (!Array.isArray(v)) return [];
    return v.map((x) => (typeof x === 'string' ? x : String(x)));
  };

  return {
    id: row.id as string,
    loopId: row.loop_id as string,
    workspaceId: (row.workspace_id as string | null) ?? null,
    pathSource: (row.path_source as PathInstanceSource) ?? 'seeded',
    spineOrgUnitIds: asStringArray(row.spine_org_unit_ids),
    remainingSpine: asStringArray(row.remaining_spine),
    traversed: Array.isArray(row.traversed)
      ? (row.traversed as PathInstanceTraverseStop[])
      : [],
    splits: Array.isArray(row.splits) ? (row.splits as Array<Record<string, unknown>>) : [],
    adjustedBy: (row.adjusted_by as string | null) ?? null,
    adjustedAt: (row.adjusted_at as string | null) ?? null,
    createdAt: row.created_at as string,
    updatedAt: row.updated_at as string,
  };
}

export interface EnsurePathInstanceParams {
  loopId: string;
  spineOrgUnitIds: string[];
  pathSource?: PathInstanceSource;
  actorId: string;
}

export interface AdjustPathInstanceParams {
  loopId: string;
  ballId?: string | null;
  remainingOrgUnitIds: string[];
  mode?: 'rewrite_remaining' | 'append_stops';
  actorId: string;
}

export interface AggregateBallsParams {
  parentBallId: string;
  mergedContent?: Record<string, unknown>;
  actorId: string;
}
